"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var collectedOptions_1 = require("../config/collectedOptions");
var mobx_1 = require("mobx");
var allOptions = mobx_1.computed(function () {
    var allOptions = [];
    collectedOptions_1.default().forEach(function (category) {
        category.subcategories.forEach(function (subcategory) {
            allOptions = allOptions.concat(subcategory.options.map(function (option) { return (tslib_1.__assign({}, option, { categoryKey: category.key, subcategoryKey: subcategory.key })); }));
        });
    });
    return allOptions;
});
exports.default = function () { return allOptions.get(); };
//# sourceMappingURL=getAllOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/selectors/getAllOptions.js
// module id = 3771
// module chunks = 2